/** 工单状态 */
export const WORK_ORDER_STATUS = {
  PENDING_ASSIGN: "待分配",
  PENDING_ACCEPT: "待接单",
  IN_REPAIR: "维修中",
  PENDING_CONFIRM: "待确认",
  COMPLETED: "已完成",
  CANCELLED: "已取消",
};

/** 紧急程度 */
export const URGENCY_LEVEL = {
  NORMAL: "正常",
  URGENT: "紧急",
  CRITICAL: "特急",
};

/** 进度节点 */
export const PROGRESS_NODE = {
  ON_SITE: "现场",
  DIAGNOSING: "诊断",
  WAITING_PARTS: "等待备件",
  REPAIR_DONE: "维修完成",
};

/** 售后人员业务状态 */
export const STAFF_BIZ_STATUS = {
  BUSY: "忙碌",
  IDLE: "空闲",
};

export function statusLabel(code) {
  return WORK_ORDER_STATUS[code] || code || "-";
}

export function urgencyLabel(code) {
  return URGENCY_LEVEL[code] || code || "-";
}

export function progressLabel(code) {
  if (code == null || code === "") return "-";
  return PROGRESS_NODE[code] || code;
}

export function staffBizLabel(code) {
  return STAFF_BIZ_STATUS[code] || code || "-";
}

/** 状态标签颜色（大屏青霓虹风格） */
export function statusTagStyle(code) {
  const map = {
    PENDING_ASSIGN: { background: "rgba(144,147,153,0.28)", color: "#c8d0d8", border: "1px solid #909399" },
    PENDING_ACCEPT: { background: "rgba(255,169,64,0.22)", color: "#ffa940", border: "1px solid #ffa940" },
    IN_REPAIR: { background: "rgba(0,229,255,0.18)", color: "#00e5ff", border: "1px solid #00e5ff" },
    PENDING_CONFIRM: { background: "rgba(155,89,182,0.25)", color: "#c39bd3", border: "1px solid #9b59b6" },
    COMPLETED: { background: "rgba(46,204,113,0.22)", color: "#2ecc71", border: "1px solid #2ecc71" },
    CANCELLED: { background: "rgba(144,147,153,0.22)", color: "#95a5a6", border: "1px solid #7f8c8d" },
  };
  return map[code] || { background: "rgba(0,140,200,0.22)", color: "#58e2f1", border: "1px solid #00e5ff" };
}

const CHART_COLORS = [
  "#00e5ff",
  "#58e2f1",
  "#1890ff",
  "#ffa940",
  "#2ecc71",
  "#ff6b6b",
  "#9b59b6",
  "#1abc9c",
];

export function chartColor(index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}
